import { render, staticRenderFns } from "./dirs.vue?vue&type=template&id=74d0cc22&"
import script from "./dirs.vue?vue&type=script&lang=js&"
export * from "./dirs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports